import type { TourStep } from '../types';

export const compDatabaseSteps: TourStep[] = [
  {
    target: '[data-tour="comp-header"]',
    title: 'Your Comp Database',
    content:
      'Every comparable sale you save from appraisals is stored here for quick reference and reuse. Your library grows automatically as you complete reports.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="comp-filters"]',
    title: 'Search for Comps',
    content:
      'Search by address, or filter by comp type (sale, listing, contract), property type, and location. Try typing an address to search.',
    placement: 'bottom',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'I\'ve searched',
  },
  {
    target: '[data-tour="comp-table"]',
    title: 'Your Comp Library',
    content:
      'Each comp shows address, city, type, property class, privacy status, and save date. Click any row to view full details or edit.',
    placement: 'top',
    spotlightClicks: true,
  },
  {
    target: '[data-tour="comp-table"]',
    title: 'Privacy Controls',
    content:
      'Comps marked private are only visible to you. Public comps are shared across your team. Use the lock icon to toggle privacy per entry.',
    placement: 'top',
    spotlightClicks: true,
  },
  {
    target: '[data-tour="comp-filters"]',
    title: 'Building Your Library',
    content:
      'Your database grows as you complete appraisals. You can also manually add comps from this page for properties you want to track outside of a report.',
    placement: 'bottom',
  },
];
